/**
 * Incoming calls queued while the agent is already on another call.
 *
 * @param {Array<{ callId?: string }>} incomingPhones
 * @param {{ callId?: string } | null | undefined} activeCall
 * @returns {Array}
 */
export default function getWaitingIncomingCalls(incomingPhones, activeCall) {
  const activeCallId = activeCall?.callId;
  if (!activeCallId) return [];

  return (incomingPhones ?? []).filter(
    (call) => call?.callId && call.callId !== activeCallId
  );
}
